/**
 * 모바일 사용자 여부를 확인하고, 해당하는 레이아웃으로 전환하는 미들웨어
 */
export default defineNuxtRouteMiddleware((to, from) => {
  const ua = process.server
    ? useRequestHeaders()['user-agent'] || ''
    : navigator.userAgent
  const isMobile =/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua)
  // FIXME : 테스트용 주석처리
  // // layout 전환
  // if (isMobile) {
  //   to.meta.layout = 'mobile-layout'
  // } else {
  //   to.meta.layout = 'default'
  // }
})
